import { useLoadProducts } from "../../hooks/useLoadProducts";
import "./ProductScroller.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

type ProductScrollerProps = {
  slides?: number;
  delay?: number;
  showHeader?: boolean;
};

function ProductScroller({
  slides = 4,
  delay = 4000,
  showHeader = false,
}: ProductScrollerProps) {
  const products = useLoadProducts();

  return (
    <div className="product-scroller-view">
      {showHeader && (
        <div className="product-scroller-header">
          <h1>EXPLORE OUR FRESH PRODUCE</h1>
        </div>
      )}
      <div className="row m-0 pt-3 pb-3">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={10}
          slidesPerView={slides}
          centeredSlides={false}
          navigation={true}
          speed={800}
          loop={true}
          autoplay={{
            delay: delay,
            disableOnInteraction: false,
          }}
          className="products-swiper"
        >
          {Object.entries(products)?.map(([key, value]) => {
            return (
              <SwiperSlide key={key} className="slider-product-image">
                <img
                  src={value}
                  alt={key}
                  onContextMenu={(e) => e.preventDefault()}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
}

export default ProductScroller;
